export default {
    data() {
        return {
            tabIndex: 1,
        };
    }
};

